import React, { useState, useContext} from "react";

import { AppContext } from "../../AppContext";
import { fetchCall } from "../../common/FetchHelpers";

import DocumentForm from "./DocumentForm";

const DocumentEditor = (props)=> {

    const reqUrl = "api/document/create";

    const [appContext, setAppContext] = useContext(AppContext);

    const [showEditor, setShowEditor] = useState(true);
    const [showPreview, setShowPreview] = useState(false);
    const [detailMode, setDetailMode] = useState("PREVIEW");
    const [formData, setFormData] = useState(props.formData);
    const [formState,setFormState] = useState(props.editorMode);



    let submittedFor = '';

    const defaultConfig = {
        editorMode:props.editorMode,
        detailMode:detailMode,
        title: "Review your request before submitting",
        status: {
          state: "",
          message: "",
        },
        btnOk: {
          label: "Submit",
          handler: handleSubmit,
        },
        btnCancel: {
          label: "Edit Before Submit",
          handler: handleClosePreview,
        },
      };
      const [detailConfig, setDetailConfig] = useState(defaultConfig);
    


    const onUserSelected = (e)=>{
      submittedFor = e.target.value;
    };
  


    const handleSubmit = (docItem)=>{
        
        const jsonData = {...docItem,submittedFor:submittedFor?submittedFor:null,template:"",formData:JSON.stringify(docItem.formData)};

        console.log(jsonData);
        
        const reqOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(jsonData),
        };

        fetchCall(reqUrl, reqOptions)
          .then((result)=>{
            setFormState("SAVED");

          })
          .catch((err)=>{
            console.log("Error, with message:", err.statusText);
            setShowEditor(false);
            setShowPreview(false);

          });
    };

    const handleClosePreview = () => {

        setShowEditor(true);
        setShowPreview(false);
      };
    

    return (
        <>
            {showEditor && (<DocumentForm
                editorMode = {formState}
                editorItem={props.editorItem}
                onUserSelected={onUserSelected}
                handleSaveClick={handleSubmit}
                handleCancel={props.handleClose}
                />)}
        </>
    )
}

export default DocumentEditor
